export default "__VITE_ASSET__DUx$7cFf__"